import * as THREE from 'three';

/**
 * @param {THREE.Texture} texture
 * @param {{
 *   opacity?: number;
 *   size?: number;
 *   offsetX?: number;
 *   offsetZ?: number;
 *   rotationDeg?: number;
 * }} options
 */
export function createMapBackgroundMesh(texture, options = {}) {
  const {
    opacity = 0.9,
    size = 16,
    offsetX = 0,
    offsetZ = 0,
    rotationDeg = 0,
  } = options;

  texture.colorSpace = THREE.SRGBColorSpace;

  const geometry = new THREE.PlaneGeometry(1, 1);
  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    opacity,
    depthWrite: false,
    side: THREE.DoubleSide,
  });

  const mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.x = -Math.PI / 2;
  mesh.rotation.z = THREE.MathUtils.degToRad(rotationDeg);
  mesh.position.set(offsetX, 0.015, offsetZ);
  mesh.scale.set(size, size, 1);
  mesh.renderOrder = 0;

  return mesh;
}

/**
 * @param {THREE.Mesh} mesh
 * @param {{
 *   opacity?: number;
 *   size?: number;
 *   offsetX?: number;
 *   offsetZ?: number;
 *   rotationDeg?: number;
 *   visible?: boolean;
 * }} options
 */
export function updateMapBackgroundMesh(mesh, options = {}) {
  const {
    opacity = 0.9,
    size = 16,
    offsetX = 0,
    offsetZ = 0,
    rotationDeg = 0,
    visible = true,
  } = options;

  mesh.visible = visible;
  mesh.material.opacity = opacity;
  mesh.position.set(offsetX, 0.015, offsetZ);
  mesh.rotation.z = THREE.MathUtils.degToRad(rotationDeg);
  mesh.scale.set(size, size, 1);
}

export function disposeMapBackgroundMesh(mesh) {
  mesh.geometry.dispose();
  mesh.material.map?.dispose();
  mesh.material.dispose();
}
